import { LoadState } from "../../../constants/enums";

export interface IBusinessInterruptionFormValues {
  // Section 01 - Applicant & Coverage Basis
  application_type: "new_application" | "renewal";
  policy_number: string;
  date_prepared: string;
  effective_date: string;
  expiry_date: string;
  named_insured: string;
  description_of_operations: string;
  location_of_premises: string;

  // Section 02 - Date headers
  actual_year_ended: string;
  estimated_year_ending: string;

  // Revenue (A)
  revenue_goods_services_actual: number;
  revenue_goods_services_estimated: number;
  revenue_rental_income_actual: number;
  revenue_rental_income_estimated: number;

  // Other Earnings (B)
  other_earnings_cash_discounts_actual: number;
  other_earnings_cash_discounts_estimated: number;
  other_earnings_commissions_actual: number;
  other_earnings_commissions_estimated: number;

  // Computed Total C (A + B)
  total_c_actual: number;
  total_c_estimated: number;

  // Variable Expenses
  expense_products_sold_actual: number;
  expense_products_sold_estimated: number;
  expense_materials_supplies_actual: number;
  expense_materials_supplies_estimated: number;
  expense_services_purchased_actual: number;
  expense_services_purchased_estimated: number;
  expense_utilities_actual: number;
  expense_utilities_estimated: number;
  expense_custom_1_label: string;
  expense_custom_1_actual: number;
  expense_custom_1_estimated: number;
  expense_custom_2_label: string;
  expense_custom_2_actual: number;
  expense_custom_2_estimated: number;
  expense_custom_3_label: string;
  expense_custom_3_actual: number;
  expense_custom_3_estimated: number;

  // Computed Total D (sum of all variable expenses)
  total_d_actual: number;
  total_d_estimated: number;

  // Payroll (E)
  ordinary_payroll_expense_actual: number;
  ordinary_payroll_expense_estimated: number;

  // Computed Business Income F = C - D - E
  business_income_f_actual: number;
  business_income_f_estimated: number;

  // Period of Indemnity
  period_of_indemnity: "12" | "18" | "24" | "other";
  period_of_indemnity_other_months: number;

  // Computed Amount of Insurance
  amount_of_insurance: number;

  // Payroll Coverage Period
  payroll_coverage_period: "90" | "120" | "other";
  payroll_coverage_period_other_days: number;

  // Declaration
  applicant_signature: string;
  applicant_date_signed: string;
  applicant_print_name: string;
  applicant_title: string;
  broker_name: string;
  broker_print_name: string;
  broker_signature: string;
  broker_date_signed: string;
}

export interface IBusinessInterruptionRecord {
  business_interruption_id: number;
  incremental_number: number;
  customer_policy_id: number;
  named_insured: string;
  application_type: string;
  amount_of_insurance: number;
  period_of_indemnity: string;
  insert_ts: string;
  created_by_name: string;
  [key: string]: any;
}

export interface IBusinessInterruptionListFetchParams {
  customer_policy_id: number;
  pageNo: number;
  pageLimit: number;
  itemPerPage: number;
  from_date?: string;
  to_date?: string;
}

export interface IBusinessPolicyBIState {
  list: {
    data: IBusinessInterruptionRecord[];
    loading: LoadState;
    totalRecords: number;
  };
  data: IBusinessInterruptionFormValues;
  loading: LoadState;
  saveLoading: LoadState;
  error: string | null;
}

export const defaultBusinessInterruptionFormValues: IBusinessInterruptionFormValues = {
  application_type: "new_application",
  policy_number: "",
  date_prepared: "",
  effective_date: "",
  expiry_date: "",
  named_insured: "",
  description_of_operations: "",
  location_of_premises: "",
  actual_year_ended: "",
  estimated_year_ending: "",
  revenue_goods_services_actual: 0,
  revenue_goods_services_estimated: 0,
  revenue_rental_income_actual: 0,
  revenue_rental_income_estimated: 0,
  other_earnings_cash_discounts_actual: 0,
  other_earnings_cash_discounts_estimated: 0,
  other_earnings_commissions_actual: 0,
  other_earnings_commissions_estimated: 0,
  total_c_actual: 0,
  total_c_estimated: 0,
  expense_products_sold_actual: 0,
  expense_products_sold_estimated: 0,
  expense_materials_supplies_actual: 0,
  expense_materials_supplies_estimated: 0,
  expense_services_purchased_actual: 0,
  expense_services_purchased_estimated: 0,
  expense_utilities_actual: 0,
  expense_utilities_estimated: 0,
  expense_custom_1_label: "",
  expense_custom_1_actual: 0,
  expense_custom_1_estimated: 0,
  expense_custom_2_label: "",
  expense_custom_2_actual: 0,
  expense_custom_2_estimated: 0,
  expense_custom_3_label: "",
  expense_custom_3_actual: 0,
  expense_custom_3_estimated: 0,
  total_d_actual: 0,
  total_d_estimated: 0,
  ordinary_payroll_expense_actual: 0,
  ordinary_payroll_expense_estimated: 0,
  business_income_f_actual: 0,
  business_income_f_estimated: 0,
  period_of_indemnity: "12",
  period_of_indemnity_other_months: 0,
  amount_of_insurance: 0,
  payroll_coverage_period: "90",
  payroll_coverage_period_other_days: 0,
  applicant_signature: "",
  applicant_date_signed: "",
  applicant_print_name: "",
  applicant_title: "",
  broker_name: "",
  broker_print_name: "",
  broker_signature: "",
  broker_date_signed: "",
};

export const defaultBusinessPolicyBIState: IBusinessPolicyBIState = {
  list: {
    data: [],
    loading: LoadState.NotLoaded,
    totalRecords: 0,
  },
  data: defaultBusinessInterruptionFormValues,
  loading: LoadState.NotLoaded,
  saveLoading: LoadState.NotLoaded,
  error: null,
};
